import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import DateInput from '../ui/date-input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import api from '../../utils/api';
import { useToast } from '../../hooks/use-toast';

export default function TcEditModal({ open, onOpenChange, student, onSaved }) {
  const { toast } = useToast();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (student) {
      setForm({
        leaving_date: student.leaving_date || '',
        leaving_reason: student.leaving_reason || '',
        tc_number: student.tc_number || '',
        promoted_to_class: student.promoted_to_class || '',
      });
    }
  }, [student]);

  const save = async () => {
    if (!student?.id) return;
    setSaving(true);
    try {
      await api.put(`/reports/tc/${student.id}`, form);
      toast({ title: 'TC details saved' });
      onSaved?.();
      onOpenChange(false);
    } catch (e) {
      toast({ title: 'Save failed', description: e?.response?.data?.message, variant: 'destructive' });
    } finally {
      setSaving(false);
    }
  };

  const name = student ? [student.first_name, student.last_name].filter(Boolean).join(' ') : '';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>TC details — {name}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-3 py-2">
          <div><Label>TC number</Label><Input value={form.tc_number || ''} onChange={(e) => setForm({ ...form, tc_number: e.target.value })} /></div>
          <div><Label>Leaving date</Label><DateInput value={form.leaving_date || ''} onChange={(v) => setForm({ ...form, leaving_date: v })} /></div>
          <div><Label>Promoted to class</Label><Input value={form.promoted_to_class || ''} onChange={(e) => setForm({ ...form, promoted_to_class: e.target.value })} /></div>
          <div><Label>Reason for leaving</Label><Textarea value={form.leaving_reason || ''} onChange={(e) => setForm({ ...form, leaving_reason: e.target.value })} rows={3} /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
